import {IController, IModule} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {AvtaleRessurs, Avtalestatus} from "felles/tjenester/ressurser/AvtaleRessurs";

const css = require('./avtaler.scss');

export class AvtalerKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmGruppeAvtaler', {
                bindings: {},
                controller: AvtalerKontroller.forInjisering(),
                template: require('./avtaler.html')
            });
    }

    static forInjisering() {
        return [
            AvtaleRessurs.regNavn,
            AvtalerKontroller
        ]
    }

    constructor(private avtalerRes: AvtaleRessurs) {
    }

    avtaler: { avtale: l.AvtaleModell; avtalestatus: Avtalestatus; }[];

    $onInit(): void {
        this.lastData();
    }


    // hjelpemetoder

    private lastData() {
        this.avtalerRes.finnAvtalerBrukerErKontaktpersonFor().$promise
            .then(avtaler => {
                this.avtaler = _(avtaler)
                    .map(avtale => ({
                        avtale: avtale,
                        avtalestatus: new Avtalestatus(avtale)
                    }))
                    .value();
            });
    }


}
